module.exports = __webpack_public_path__ + "static/media/mainLogo.ed87c895.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mainLogo.png
// module id = 84
// module chunks = 0